// Backend seam for Autopilot — the production-feasibility recommendation feed.
// The deterministic engine + ranking live server-side; the UI only renders.
import { apiClient } from '@/services/api';

export async function getRecommendations() {
  try { return await apiClient.get('/autopilot/recommendations'); }
  catch (_) { return { recommendations: [], total: 0 }; }
}

export async function refreshAutopilot() {
  return apiClient.post('/autopilot/refresh', {});
}

export async function getDataReadiness() {
  try { return await apiClient.get('/autopilot/data-readiness'); }
  catch (_) { return null; }
}

export async function getExplanation(id) {
  try { return await apiClient.get(`/autopilot/recommendations/${id}/explanation`); }
  catch (_) { return null; }
}

export async function approveRecommendation(id, actions) {
  return apiClient.post(`/autopilot/recommendations/${id}/approve`, { actions: actions || null });
}

export async function dismissRecommendation(id, reason) {
  return apiClient.post(`/autopilot/recommendations/${id}/dismiss`, { reason: reason || null });
}
